import React from "react";

export default function About() {
  return (
    <section className="bg-white text-gray-800">
      {/* Hero Section */}
      <section className="relative bg-[linear-gradient(160deg,#1e40af_0%,#0891b2_100%)] text-white py-20">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-4xl sm:text-5xl font-extrabold mb-4">
            About SynergySoft
          </h1>
          <p className="text-blue-100 max-w-2xl mx-auto text-lg">
            Empowering businesses with seamless, secure, and scalable hosting solutions.
          </p>
        </div>
      </section>

      {/* Company Story */}
      <div className="max-w-6xl mx-auto px-6 py-16 leading-relaxed">
        <h2 className="text-3xl font-semibold text-gray-800 mb-6 text-center">
          Who We Are
        </h2>
        <p className="mb-6 text-lg text-gray-700">
          Founded with a mission to simplify the digital experience,
          <span className="font-semibold text-blue-600"> SynergySoft </span>
          has evolved into a trusted name in web hosting,
          and domain management. Our team of innovators and engineers is driven
          by a single goal — helping businesses build a reliable and secure online presence.
        </p>
        <p className="mb-6 text-lg text-gray-700">
          We believe hosting should be <span className="font-semibold">fast, transparent,</span>
          and <span className="font-semibold">human-centered.</span> That’s why every
          service we provide — from shared hosting to enterprise-grade cloud
          infrastructure — is built around simplicity, performance, and trust.
        </p>

        {/* Vision, Mission, Values */}
        <div className="grid md:grid-cols-3 gap-10 mt-12">
          <div className="bg-[#f8faff] p-8 rounded-2xl shadow hover:shadow-lg transition-all duration-300">
            <h3 className="text-xl font-semibold text-blue-600 mb-3">💡 Our Vision</h3>
            <p>
              To redefine hosting through innovation, performance, and people-first support,
              enabling every creator and business to thrive online.
            </p>
          </div>
          <div className="bg-[#f8faff] p-8 rounded-2xl shadow hover:shadow-lg transition-all duration-300">
            <h3 className="text-xl font-semibold text-blue-600 mb-3">🚀 Our Mission</h3>
            <p>
              To deliver secure, scalable, and lightning-fast digital infrastructure backed by
              24/7 expert support and unmatched reliability.
            </p>
          </div>
          <div className="bg-[#f8faff] p-8 rounded-2xl shadow hover:shadow-lg transition-all duration-300">
            <h3 className="text-xl font-semibold text-blue-600 mb-3">💙 Our Values</h3>
            <p>
              Integrity, innovation, and reliability are at the core of everything we do —
              because our customers’ trust is our greatest achievement.
            </p>
          </div>
        </div>
      </div>

      {/* Why Choose Us */}
      <div className="bg-[#f8faff] py-16 border-t border-gray-200">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-semibold text-gray-800 mb-8">
            Why Choose <span className="text-blue-600">SynergySoft?</span>
          </h2>
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 text-left">
            {[
              {
                title: "⚡ Blazing Performance",
                desc: "Experience cutting-edge speed powered by SSD storage, CDN optimization, and next-gen caching technology.",
              },
              {
                title: "🔒 Rock-Solid Security",
                desc: "Enjoy enterprise-grade protection with firewalls, DDoS defense, and free SSL certificates.",
              },
              {
                title: "🌍 Global Infrastructure",
                desc: "Our worldwide data centers guarantee maximum uptime, stability, and low latency for your business.",
              },
              {
                title: "🤝 Customer-First Support",
                desc: "Get help from real experts, 24/7. No bots — just fast, friendly, human support.",
              },
              {
                title: "💰 Transparent Pricing",
                desc: "We believe in honesty — no hidden fees, surprise renewals, or confusing fine print.",
              },
              {
                title: "☁️ Scalable Solutions",
                desc: "From personal websites to large-scale applications, our cloud grows as your needs do.",
              },
            ].map((item, index) => (
              <div
                key={index}
                className="p-6 bg-white rounded-2xl shadow hover:shadow-lg transition-all duration-300"
              >
                <h3 className="text-lg font-semibold text-blue-600 mb-2">
                  {item.title}
                </h3>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="text-center py-20 bg-cover bg-center relative"
        style={{
          backgroundImage: "url('/images/banner4.jpg')",
        }}
      >
        <div className="absolute inset-0 bg-black/60"></div>
        <div className="relative z-10 container mx-auto px-6">
          <h2 className="text-3xl font-bold text-white mb-4">
            Ready to take your business online?
          </h2>
          <p className="mb-6 text-gray-200 text-lg max-w-xl mx-auto">
            Join thousands of businesses that trust <span className="font-semibold">SynergySoft</span>
            for secure, scalable, and high-performance hosting.
          </p>
          <a
            href="/domains"
            className="inline-block bg-white text-blue-600 font-semibold px-8 py-3 rounded-full shadow hover:shadow-lg transition-transform transform hover:scale-105"
          >
            Get Started
          </a>
        </div>
      </div>
    </section>
  );
}
